import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, PaginatedResponse } from '../../types/app';

interface UsersState {
  users: PaginatedResponse<User> | null;
  selectedUser: User | null;
  isLoading: boolean;
  isUpdating: boolean;
  error: string | null;
}

const initialState: UsersState = {
  users: null,
  selectedUser: null,
  isLoading: false,
  isUpdating: false,
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    fetchUsersStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchUsersSuccess: (state, action: PayloadAction<PaginatedResponse<User>>) => {
      state.isLoading = false;
      state.users = action.payload;
      state.error = null;
    },
    fetchUsersFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    selectUser: (state, action: PayloadAction<User>) => {
      state.selectedUser = action.payload;
    },
    updateUserStart: (state) => {
      state.isUpdating = true;
      state.error = null;
    },
    updateUserSuccess: (state, action: PayloadAction<User>) => {
      state.isUpdating = false;
      state.selectedUser = action.payload;
      
      // Update user in the list
      if (state.users) {
        const index = state.users.items.findIndex(u => u.id === action.payload.id);
        if (index !== -1) {
          state.users.items[index] = action.payload;
        }
      }
      state.error = null;
    },
    updateUserFailure: (state, action: PayloadAction<string>) => {
      state.isUpdating = false;
      state.error = action.payload;
    },
    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  selectUser,
  updateUserStart,
  updateUserSuccess,
  updateUserFailure,
  clearSelectedUser,
  clearError,
} = usersSlice.actions;

export default usersSlice.reducer; 